import { useState } from 'react'

function usePagination(totalItems, itemsPerPage = 12) {
  const [currentPage, setCurrentPage] = useState(1)

  const totalPages = Math.ceil(totalItems / itemsPerPage)

  const goToPage = (page) => {
    setCurrentPage(page)
  }

  return {
    currentPage,
    totalPages,
    goToPage
  }
}

export default usePagination
